import { User } from "@shared/models";
import { call, put, takeLatest } from "redux-saga/effects";
import { PaginatedResponse, ActionWithPayload, UpdateStatusShape, UserFilter } from "@shared/interfaces";
import { startLoading, stopLoading } from "@shared/store/actions";

import api from "../api";
import { getUsers, createUser, updateUser, updateUserStatus, createUserSession, updateUserSession } from "./actions";
import { CreateUserDto, CreateUserSessionDto, CreateUserSessionSuccess, CreateUserSuccess } from "../interfaces";

function* getUsersSaga({ payload }: ActionWithPayload<UserFilter>) {
  try {
    yield put(startLoading());
    const response: PaginatedResponse<User> = yield call(api.getUsers, payload);
    yield put(stopLoading());
    yield put(
      getUsers.success({
        ...response,
        is_clear: !payload.page,
      }),
    );
  } catch (error) {
    yield put(getUsers.failure(error as Error));
    yield put(stopLoading());
  }
}

function* createUserSaga({ payload }: ActionWithPayload<CreateUserDto>) {
  try {
    yield put(startLoading());
    const response: CreateUserSuccess = yield call(api.createUser, payload);
    yield put(stopLoading());
    yield put(createUser.success(response));
  } catch (error) {
    yield put(createUser.failure(error as Error));
    yield put(stopLoading());
  }
}

function* updateUserSaga({ payload }: ActionWithPayload<CreateUserDto & { id: number }>) {
  try {
    yield put(startLoading());
    const response: CreateUserSuccess = yield call(api.updateUser, payload);
    yield put(stopLoading());
    yield put(updateUser.success(response));
  } catch (error) {
    yield put(updateUser.failure(error as Error));
    yield put(stopLoading());
  }
}

function* updateUserStatusSaga({ payload }: ActionWithPayload<UpdateStatusShape>) {
  try {
    yield put(startLoading());
    const response: CreateUserSuccess = yield call(api.updateUserStatus, payload);
    yield put(stopLoading());
    yield put(updateUserStatus.success(response));
  } catch (error) {
    yield put(updateUserStatus.failure(error as Error));
    yield put(stopLoading());
  }
}

function* createUserSessionSaga({ payload }: ActionWithPayload<CreateUserSessionDto>) {
  try {
    yield put(startLoading());
    const response: CreateUserSessionSuccess = yield call(api.createUserSession, payload);
    yield put(stopLoading());
    yield put(createUserSession.success(response));
  } catch (error) {
    yield put(createUserSession.failure(error as Error));
    yield put(stopLoading());
  }
}

function* updateUserSessionSaga({ payload }: ActionWithPayload<number>) {
  try {
    yield put(startLoading());
    const response: CreateUserSessionSuccess = yield call(api.updateUserSession, payload);
    yield put(stopLoading());
    yield put(updateUserSession.success(response));
  } catch (error) {
    yield put(updateUserSession.failure(error as Error));
    yield put(stopLoading());
  }
}

function* userSagas() {
  yield takeLatest(getUsers.request, getUsersSaga);
  yield takeLatest(createUser.request, createUserSaga);
  yield takeLatest(updateUser.request, updateUserSaga);
  yield takeLatest(updateUserStatus.request, updateUserStatusSaga);
  yield takeLatest(createUserSession.request, createUserSessionSaga);
  yield takeLatest(updateUserSession.request, updateUserSessionSaga);
}

export default userSagas;
